import { FC } from "react";
import { ProdAttrUtils } from "../../utils/productAttributeUtils";

export const TourExtraInfo: FC<ProdDetailEleProps> = ({ d, className }) => {
  if (d?.productType !== "TOUR") return null;
  const f = (name: ProdAttrNameTourInfo) =>
    ProdAttrUtils.TOUR.getDpValue(d?.attributeList ?? [], name);
  const ls = [
    {
      value: f("AGE"),
      icon: "over-year",
    },
    // { value: f("PICKUP_TIME"), icon: "start-time" },
    {
      value: f("MEAL"),
      icon: "meal",
    },
  ].filter((x) => x.value);
  if (!ls.length) return null;
  return (
    <div className="mt-10 flex gap-20">
      {ls.map((item, index) => (
        <div key={index} className="flex gap-3">
          <img
            className="mx-auto h-[1.375rem] w-[1.375rem]"
            src={`../../assets/icons/${item.icon}.svg`}
            alt={item.icon}
          />
          <p className="text-base font-normal leading-[1.625rem] text-[#5E6D77]">
            {item.value}
          </p>
        </div>
      ))}
    </div>
  );
};
